module.exports = require("@mui/material/Tabs");